var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M16,32A16,16,0,0,1,9.772,1.257,16,16,0,0,1,22.228,30.743,15.9,15.9,0,0,1,16,32ZM14.264,14.513a5.34,5.34,0,0,0-3.447,1.366,6.812,6.812,0,0,0-1.967,3.685L8,23.557h4.358l1.906-9.041,4.892,9.039h5.121l-3.3-6.073a7.726,7.726,0,0,0,1.836-1.4A6.024,6.024,0,0,0,24.4,13.144a4.319,4.319,0,0,0-.771-3.6,3.924,3.924,0,0,0-3.178-1.4H15.669l-.79,3.72h3.6a1.06,1.06,0,0,1,.845.378,1.121,1.121,0,0,1,.2.957,1.727,1.727,0,0,1-1.61,1.313ZM11.718,8a2.047,2.047,0,1,0,2.06,2.048A2.056,2.056,0,0,0,11.718,8Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/navLogo.9036f2b9.svg";
export { ForwardRef as ReactComponent };